import {
  COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE,
  COMPANY_SETTING_HAS_DEFECT_AREA,
  COMPANY_SETTING_HAS_EXPORT_DATA,
  COMPANY_SETTING_NAME_INSPECTION_TYPE,
  COMPANY_SETTING_NAME_ORDER_TYPE,
  COMPANY_SETTING_NAME_STRING_TYPE,
  COMPANY_SETTING_NAME_TIME_ACTION_TYPE,
  COMPANY_SETTING_ENABLE_ACTIVATION,
  COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM,
  COMPANY_SETTING_FCCA_RATING,
  COMPANY_SETTING_PRODUCTION_STATUS,
  COMPANY_SETTING_OVERALL_RESULT,
  COMPANY_SETTING_SHOW_UUID,
  COMPANY_SETTING_HAS_SUPPLIER,
  COMPANY_SETTING_TYPE,
  USER_ROLE,
  COMPANY_SETTING_HIDDEN_BLOCKS,
  COMPANY_SETTING_AUDIT_RATING_TITLES,
  COMPANY_SETTING_PRODUCT_ADVANCE_FILTER_CUSTOM,
  COMPANY_SETTING_HAS_MEASUREMENT_AQL,
  COMPANY_SETTING_DEFECT_STATUS,
  COMPANY_SETTING_REPORT_COMBINED_DEFECTS,
  COMPANY_SETTING_LIVEBOARD_SETTING,
} from '@/constant/user'
import {
  getRolesRef,
  getUsersRef,
  updateRoleRef,
  getInspectorSetting,
  getCompanySettingRef,
} from './UserManagment.service'
import { filter, find, isEmpty, pick, size } from 'lodash'

export async function getAllUser(payload) {
  return (await getUsersRef(payload)).data
}

export async function getRoles() {
  // TODO implement prop isInspectorSetting

  const [{ data }, isInspectorSetting] = await Promise.all([
    getRolesRef(),
    getInspectorSetting(),
  ])

  let result = data?.data?.map((item) => {
    return {
      label: item.role,
      value: item.id,
    }
  })

  if (!isInspectorSetting) {
    result = filter(result, (elem) => elem.label !== USER_ROLE.INSPECTOR)
  }

  return result
}

export async function inspectorSetting() {
  const data = await getInspectorSetting()
  return data
}

export async function updateRoles(payload: any) {
  return await updateRoleRef(payload)
}

export async function getCompanySetting(
  settingType?: COMPANY_SETTING_TYPE | '',
  settingName?:
    | COMPANY_SETTING_NAME_INSPECTION_TYPE
    | COMPANY_SETTING_NAME_TIME_ACTION_TYPE
    | COMPANY_SETTING_NAME_ORDER_TYPE
    | COMPANY_SETTING_NAME_STRING_TYPE
    | COMPANY_SETTING_HAS_DEFECT_AREA
    | typeof COMPANY_SETTING_ENABLE_ACTIVATION
    | typeof COMPANY_SETTING_HAS_EXPORT_DATA
    | typeof COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE
    | typeof COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM
    | typeof COMPANY_SETTING_HIDDEN_BLOCKS
    | typeof COMPANY_SETTING_FCCA_RATING
    | typeof COMPANY_SETTING_PRODUCTION_STATUS
    | typeof COMPANY_SETTING_OVERALL_RESULT
    | typeof COMPANY_SETTING_SHOW_UUID
    | typeof COMPANY_SETTING_HAS_SUPPLIER
    | typeof COMPANY_SETTING_AUDIT_RATING_TITLES
    | typeof COMPANY_SETTING_PRODUCT_ADVANCE_FILTER_CUSTOM
    | typeof COMPANY_SETTING_HAS_MEASUREMENT_AQL
    | typeof COMPANY_SETTING_DEFECT_STATUS
    | typeof COMPANY_SETTING_LIVEBOARD_SETTING
    | typeof COMPANY_SETTING_REPORT_COMBINED_DEFECTS
    | '',
  pickField = []
) {
  const data = await getCompanySettingRef(settingType, settingName)

  if (!isEmpty(settingName)) {
    const findOne = find(data, ['name', settingName])
    const pickItem = pick(findOne, pickField)

    return size(pickItem) ? pickItem : findOne
  }

  return data
}
